import { render } from "./DSwitch.vue?vue&type=template&id=4c2852d2&lang=pug"
import script from "./DSwitch.vue?vue&type=script&lang=js"
export * from "./DSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__